const image = [
  {
    title: "氫能發展策略地圖",
    src: require('assets/images/home/image-thumbnails/1.jpg'),
    url: 'https://ieknet.iek.org.tw/iekppt/ppt_detail.aspx?actiontype=ppt&indu_idno=5&domain=0&sld_preid=6765'
  },
  {
    title: "電動車發展策略地圖",
    src: require('assets/images/home/image-thumbnails/2.jpg'),
    url: 'https://ieknet.iek.org.tw/iekppt/ppt_detail.aspx?actiontype=ppt&indu_idno=5&domain=0&sld_preid=6766'
  },
  {
    title: "德國2030 氣候行動計畫",
    src: require('assets/images/home/image-thumbnails/2030.jpg'),
    url: 'https://ieknet.iek.org.tw/iekppt/ppt_detail.aspx?actiontype=ppt&indu_idno=5&domain=90&sld_preid=6695'
  },
  {
    title: "日本綠色成長戰略",
    src: require('assets/images/home/image-thumbnails/japan-green.jpg'),
    url: 'https://ieknet.iek.org.tw/iekppt/ppt_detail.aspx?actiontype=ppt&indu_idno=5&domain=90&sld_preid=6695'
  },
  // {
  //   title: "歐洲綠色新政",
  //   src: require('assets/images/home/image-thumbnails/eur-green.jpg'),
  // },
  {
    title: "法國能源轉型",
    src: require('assets/images/home/image-thumbnails/fra-energy.jpg'),
    url: 'https://ieknet.iek.org.tw/iekppt/ppt_detail.aspx?actiontype=ppt&indu_idno=5&domain=90&sld_preid=6695'
  },
  {
    title: "美國清潔能源政策",
    src: require('assets/images/home/image-thumbnails/06_美國清潔能源政策.jpg'),
    url: 'https://ieknet.iek.org.tw/iekppt/ppt_detail.aspx?actiontype=ppt&indu_idno=5&domain=90&sld_preid=6695'
  },
  {
    title: "英國清潔能源轉型計畫",
    src: require('assets/images/home/image-thumbnails/07_英國清潔能源轉型計畫.jpg'),
    url: 'https://ieknet.iek.org.tw/iekppt/ppt_detail.aspx?actiontype=ppt&indu_idno=5&domain=90&sld_preid=6695'
  },
  {
    title: "英國電動車產業政策",
    src: require('assets/images/home/image-thumbnails/08_英國電動車產業政策.jpg'),
    url: 'https://ieknet.iek.org.tw/iekppt/ppt_detail.aspx?actiontype=ppt&indu_idno=5&domain=90&sld_preid=6695'
  },
  {
    title: "英國電動車電池產業政策",
    src: require('assets/images/home/image-thumbnails/09_英國電動車電池產業政策.jpg'),
    url: 'https://ieknet.iek.org.tw/iekppt/ppt_detail.aspx?actiontype=ppt&indu_idno=5&domain=90&sld_preid=6695'
  },

  {
    title: "荷蘭氣候與能源政策",
    src: require('assets/images/home/image-thumbnails/10_荷蘭氣候與能源政策.jpg'),
    url: 'https://ieknet.iek.org.tw/iekppt/ppt_detail.aspx?actiontype=ppt&indu_idno=5&domain=90&sld_preid=6695'
  },
  {
    title: "德國電池產業政策",
    src: require('assets/images/home/image-thumbnails/11_德國電池產業政策.jpg'),
    url: 'https://ieknet.iek.org.tw/iekppt/ppt_detail.aspx?actiontype=ppt&indu_idno=5&domain=90&sld_preid=6695'
  },
  {
    title: "德國電動車產業政策",
    src: require('assets/images/home/image-thumbnails/12_德國電動車產業政策.jpg'),
    url: 'https://ieknet.iek.org.tw/iekppt/ppt_detail.aspx?actiontype=ppt&indu_idno=5&domain=90&sld_preid=6695'
  },
]

export default image;